
export default {
  // Auth-related translations
  "sign_in": "Anmelden",
  "sign_up": "Registrieren",
  "email_address": "E-Mail-Adresse",
  "password": "Passwort",
  "new_password": "Neues Passwort",
  "confirm_password": "Passwort bestätigen",
  "forgot_password": "Passwort vergessen?",
  "reset_password": "Passwort zurücksetzen",
  "verification_code": "Bestätigungscode",
  "enter_verification_code": "Geben Sie den 6-stelligen Code ein, der an Ihre E-Mail gesendet wurde",
  "passwords_dont_match": "Passwörter stimmen nicht überein",
  "password_too_short": "Passwort muss mindestens 8 Zeichen lang sein",
  "invalid_code": "Ungültiger oder abgelaufener Code",
  "invalid_code_format": "Der Bestätigungscode muss eine 6-stellige Zahl sein",
  "password_reset_success": "Passwort erfolgreich zurückgesetzt",
  "send_reset_link": "Temporäres Passwort senden",
  "reset_link_sent": "Link zum Zurücksetzen wurde an Ihre E-Mail gesendet",
  "temp_password_sent": "Temporäres Passwort wurde an Ihre E-Mail gesendet",
  "reset_link_error": "Fehler beim Senden des Links zum Zurücksetzen. Bitte versuchen Sie es später erneut.",
  "email_delivery_not_configured": "E-Mail-Versand ist nicht konfiguriert. Bitte kontaktieren Sie den Administrator.",
  "for_testing_use": "Für Entwicklungstests können Sie Supabase CLI oder Dashboard zur Benutzerverwaltung verwenden",
  "processing": "Verarbeitung...",
  "back": "Zurück",
  "verify_code": "Bestätigungscode eingeben",
  "email_not_received": "E-Mail nicht erhalten?",
  "leave_page_warning": "Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie diese Seite verlassen möchten? Ihr Fortschritt beim Zurücksetzen des Passworts geht verloren.",
  "reset_link_required": "Ein gültiger Link zum Zurücksetzen ist erforderlich, um Ihr Passwort zurückzusetzen",
  // New rate limit messages
  "reset_rate_limit_exceeded": "E-Mail-Ratenlimit überschritten. Bitte warten Sie, bevor Sie es erneut versuchen.",
  "reset_rate_limit_message": "Bitte warten Sie {{seconds}} Sekunden, bevor Sie ein weiteres temporäres Passwort anfordern.",
  "wait_before_retry": "Bitte warten Sie vor einem erneuten Versuch",
  // Temporary password messages
  "password_reset_required": "Sie müssen Ihr Passwort ändern, um fortzufahren",
  "temp_password_instructions": "Sie verwenden ein temporäres Passwort. Bitte erstellen Sie ein neues Passwort.",
  
  // Username dialog related translations
  "create_username": "Benutzernamen erstellen",
  "username_required_description": "Bitte erstellen Sie einen Benutzernamen, um fortzufahren. Ihr Benutzername wird für andere Benutzer sichtbar sein.",
  "username": "Benutzername",
  "username_placeholder": "Benutzernamen eingeben",
  "username_requirements": "Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
  "save_username": "Benutzernamen speichern",
  "username_taken": "Dieser Benutzername ist bereits vergeben. Bitte versuchen Sie einen anderen.",
  "username_set_success": "Benutzername wurde erfolgreich festgelegt!",
  "username_set_error": "Fehler beim Festlegen des Benutzernamens. Bitte versuchen Sie es erneut.",
  "auth_error": "Authentifizierungsfehler. Bitte melden Sie sich erneut an.",
  "sign_in_success": "Erfolgreich angemeldet!",
  "sign_in_failed": "Anmeldung fehlgeschlagen",
  "completing_sign_in": "Anmeldung wird abgeschlossen...",
  "please_wait": "Bitte warten Sie während wir Ihre Anmeldedaten überprüfen.",
  "or_continue_with": "Oder fortfahren mit",
  "or_with_email": "Oder mit E-Mail",
  "continue_with_google": "Mit Google fortfahren",
  "dont_have_account": "Sie haben noch kein Konto?",
  "already_have_account": "Sie haben bereits ein Konto?",
  "magic_link_sent": "Magic-Link an Ihre E-Mail gesendet",
  "magic_link_error": "Fehler beim Senden des Magic-Links. Bitte versuchen Sie es später erneut.",
  "send_magic_link": "Magic-Link senden"
};
